import {
  Card,
  Col,
  Row,
  Button,
  Form,
  Input,
  DatePicker,
  Select,
  message,
} from "antd";
import Dragger from "antd/es/upload/Dragger";
import React from "react";
import MultiSelect from "../../../../../components/common/MultiSelect";
import PageHeading from "../../../../../components/common/PageHeading";

export const Propertiesunitscampaigns = [
  "test1 - 912 n creek dr  edmond, OK 73034",
  "test2 - 912 n creek dr  edmond, OK 73034 - $0.00",
  "test3 - 1800 canyon park circle  edmond, OK 73013",
  "test4 - 912 n creek dr  edmond, OK 73034 - $0.00",
  "test 5 - 1800 canyon park circle  edmond, OK 73013 - $0.00",
];

const props = {
  name: "file",
  multiple: true,
  action: "https://www.mocky.io/v2/5cc8019d300000980a055e76",
  onChange(info) {
    const { status } = info.file;
    if (status !== "uploading") {
      console.log(info.file, info.fileList);
    }
    if (status === "done") {
      message.success(`${info.file.name} file uploaded successfully.`);
    } else if (status === "error") {
      message.error(`${info.file.name} file upload failed.`);
    }
  },
  onDrop(e) {
    console.log("Dropped files", e.dataTransfer.files);
  },
};
const BulkRecurringCharges = () => {
  const onChange = (value) => {
    console.log(`selected ${value}`);
  };
  const onSearch = (value) => {
    console.log("search:", value);
  };
  return (
    <div>
      <PageHeading heading="Bulk Recurring Charges" />

      <Card title="Download Your Template" bordered={false}>
        <p>
          Your template contains your unique Occupancy IDs which are required
          for upload.
        </p>
        <br />
        <Form
          name="basic"
          initialValues={{
            remember: true,
          }}
          autoComplete="off"
        >
          <Row>
            <Col span={12} offset={2}>
              <Form.Item label="Properties" name="Properties">
                <MultiSelect
                  options={Propertiesunitscampaigns}
                  placeholder="Search by property, association, group, portfolio, or owner"
                />
                <span className="form__row__hint">
                  By default all properties and associations will be included.
                </span>
              </Form.Item>
            </Col>
          </Row>
        </Form>
        <br /> <Button>Download Template</Button>
      </Card>
      <br />
      <Form
        name="basic"
        initialValues={{
          remember: true,
        }}
        autoComplete="off"
        layout="vertical"
      >
        <Card title="Upload Your Recurring Charges" bordered={false}>
          <Row>
            <Col span={6}>
              <Form.Item label="Start Date" name="StartDate" required>
                <DatePicker format="MM-DD-YYYY" style={{ width: "100%" }} />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={6}>
              <Form.Item label="End Date" name="EndDate">
                <DatePicker format="MM-DD-YYYY" style={{ width: "100%" }} />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <Form.Item label="GL Account" name="GLAccount" required>
                <Select
                  showSearch
                  allowClear
                  placeholder="Start typing to search"
                  optionFilterProp="children"
                  onChange={onChange}
                  onSearch={onSearch}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  options={[
                    {
                      label: "Income",
                      options: [
                        {
                          label: "Delinquency",
                          value: "Delinquency",
                        },
                        {
                          label: "Gross Potential Rent",
                          value: "Gross Potential Rent",
                        },
                      ],
                    },
                    {
                      label: "Liability",
                      options: [
                        {
                          label: "Clearing Account",
                          value: "Security Deposit Liability",
                        },
                      ],
                    },
                  ]}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <Form.Item label="Description" name="Description">
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <Dragger {...props}>
                <p className="ant-upload-text">Drag File Here</p>
                <p className="ant-upload-text">or</p>
                <p className="ant-upload-hint">
                  <Button>Choose File to Upload</Button>
                </p>
              </Dragger>
            </Col>
          </Row>
        </Card>

        <Row gutter={16} style={{ marginTop: "12px" }}>
          <Col>
            <Button type="primary">Submit</Button>
          </Col>
          <Col>
            <Button>Cancel</Button>
          </Col>
        </Row>
      </Form>
      <div className="RightSidebar"></div>
    </div>
  );
};

export default BulkRecurringCharges;
